import { CalendarOutlined, PlusCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  message,
  Pagination,
  PaginationProps,
  Row,
  Select,
  Space,
  Table,
  TableColumnsType,
  TableProps,
  Tag,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { initialInform, OptionFilter, Tank, Filter, ControlException, OptionMaster, Emission } from "src/entity/tank/tank.entity";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import { canEditTable, canViewTable } from "../../PermissionCheck/PermissionCheck";
import { EmptyString } from "src/entity/common/unit.constant";
import VerticalCenter from "src/components/WrapCenter/VerticalCenter";
import { BsPencilSquare, BsTrashFill } from "react-icons/bs";
import VocsModal from "src/components/Modal";
import { componentPalette } from "src/theme/component-palette";
import { settingStore } from "src/stores/setting-store";
import {
  calculateReportVocEmission,
  createSetupTank,
  deleteSetupTankById,
  getOptions,
  getSetupTank,
  getYear,
  updateSetupTank,
} from "src/services/tank.service";
import { companyStore } from "src/stores/company-store";
import { convertedDateRangesFromFormat, covertedRangesDateToString } from "src/utils/date-time";
import { CommonSuccess } from "src/entity/common/menus-enum.enum";
import SetupTankModal from "./SetupTankModal";
import { replaceUndefinedWithNull, trimAllKey } from "src/utils/utils-object";
import axios from "axios";
import { tankStore } from "src/stores/tank-store";
import Warning from "src/components/GlobalIconPart/Warning";
import "./SetupTankTable.css";
import { generateYearArray } from "src/utils/array";
import { addCenterAlign } from "src/components/AntdCustomPart/TableTitle.tsx/TableTitle";

type OnChange = NonNullable<TableProps<any>["onChange"]>;
type Filters = Parameters<OnChange>[1];
const { Text } = Typography;

const SetupTank = () => {
  const profile = profileStore(useShallow((state) => state.profile));
  const loadingProfile = profileStore(useShallow((state) => state.loading));
  const { permissions } = useNavigationMenu();
  const [companyId, setCompanyId] = useState<string>("");
  const [messageApi, contextHolder] = message.useMessage();
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<number>();
  const [optionYears, setOptionYears] = useState<number[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState<number>(0);
  const [filter, setFilter] = useState<Filters>({});
  const pageSize = 10;
  const [optionsFilter, setOptionFilter] = useState<OptionFilter[]>([]);
  const [tankData, setTankData] = useState<Tank[]>([]);
  const [showModalTank, setShowModalTank] = useState(false);
  const [mode, setMode] = useState<"insert" | "update">("insert");
  const [dataProp, setDataProps] = useState<Tank | null>(null);
  const [selectedId, setSelectedId] = useState<string>("");
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false);
  const [showModalError, setShowModalError] = useState<boolean>(false);

  const emission = settingStore(useShallow((state) => state.emission));
  const [emissionMaster, setEmissionMaster] = useState<OptionMaster[] | null>(null);
  const getEmission = settingStore(useShallow((state) => state.getEmission));

  const getAreaByCompanyId = companyStore(useShallow((state) => state.getAreaByCompanyId));
  const areaMaster = companyStore(useShallow((state) => state.dataArea));

  const getTankTypeMaster = tankStore(useShallow((state) => state.getTankType));
  const tankTypeMaster = tankStore(useShallow((state) => state.tankType));

  const getTankEmissionControlMaster = tankStore(useShallow((state) => state.getTankEmissionControl));
  const tankEmissionControlMaster = tankStore(useShallow((state) => state.tankEmissionControl));

  const onChangeYear = (value: number) => {
    setSelectedYear(value);
  };

  const fetchYear = () => {
    const years = generateYearArray();
    setOptionYears(years as number[]);
    setSelectedYear(years[0] as number);
  };

  const onOpenModal = (mode: "insert" | "update", tank: Tank) => {
    const { emissionControlDetails } = tank;
    emissionControlDetails?.forEach((item, index) => {
      const { emissionControlId } = item;
      const efficiency = getMasterLabel("efficiency", emissionControlId);
      if (typeof efficiency === "number") {
        emissionControlDetails[index] = {
          ...item,
          efficiency,
        };
      }
    });
    tank.emissionControlDetails = emissionControlDetails;
    setShowModalTank(true);
    setMode(mode);
    setDataProps(tank);
    const arrayException = covertedRangesDateToString(tank.controlExceptionDate as ControlException[]);
    tank.arrControlExceptionDate = arrayException;
    if (tank._id) {
      setSelectedId(tank._id);
    }
  };

  const calPagination = (current?: number) => {
    if (current) {
      return (current - 1) * 10;
    }
  };

  const createParamFilter = () => {
    let queryParam = "";
    let offset = 0;
    let limit = pageSize;
    if (selectedYear) {
      queryParam += `year=${selectedYear}`;
    }
    if (current) {
      let resultCalOffset = calPagination(current);
      if (resultCalOffset) {
        offset = resultCalOffset;
      }
      queryParam += `&offset=${offset}`;
    }
    if (limit) {
      queryParam += `&limit=${limit}`;
    }

    if (filter) {
      const str = Object.entries(filter)
        .filter(([, value]) => value)
        .map(([key, value]) => `&${key}=[${value?.join(",")}]`)
        .join("");
      queryParam += str;
    }

    return queryParam;
  };

  const getMasterLabel = (type: string, text: string) => {
    if (!text || typeof text != "string") return "";
    if (type === "area" && areaMaster) {
      const optValue = areaMaster.find((item) => item._id === text);
      return optValue?.areaName;
    } else if (type === "tankTypeId") {
      const optValue = tankTypeMaster.find((item) => item._id === text);
      return optValue?.tankType;
    } else if (type === "emissionControlId" && tankEmissionControlMaster) {
      const optValue = tankEmissionControlMaster.find((item) => item._id === text);
      return optValue?.emissionControl;
    } else if (type === "efficiency") {
      const optValue = tankEmissionControlMaster.find((item) => item._id === text);
      return optValue?.efficiency;
    } else {
      return text;
    }
  };

  const fetchTank = async () => {
    try {
      if (selectedYear) {
        setLoading(true);
        let offset = 0;
        let resultCalOffset = calPagination(current);
        if (resultCalOffset) {
          offset = resultCalOffset;
        }
        const query = createParamFilter();
        const response = await getSetupTank(query);
        if (response.data.code === 200) {
          const data = response.data.data.data;
          const total = response.data.data.total;
          const dataTable: Tank[] = [];
          data.forEach((item: any, index: number) => {
            const { emissionControlDetails } = item;
            emissionControlDetails.forEach((emissionItem: any) => {
              const { emissionControlId, portion } = emissionItem;
              dataTable.push({
                ...item,
                no: (index + offset + 1).toString(),
                emissionControlId,
                portion: portion,
              });
            });
          });
          // console.log("tank data", dataTable);
          // let tanks = data.map((el: any, index: number) => {
          //   return {
          //     no: (index + offset + 1).toString(),
          //     ...el,
          //   };
          // });
          if (canViewTable(permissions)) {
            setTankData([...dataTable]);
            setTotal(total);
          } else {
            setTankData([]);
            setTotal(0);
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchOption = async () => {
    try {
      if (selectedYear) {
        const response = await getOptions(selectedYear);
        if (response.data.code === 200) {
          const data = response.data.data.filter;
          setOptionFilter(data);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const deleteTank = async (id: string) => {
    try {
      setLoading(true);
      const response = await deleteSetupTankById(id);
      if (response.data.code === 200) {
        setLoading(false);
        messageApi.open({
          type: "success",
          content: CommonSuccess.DELETE_SUCCESSFULL,
        });
        fetchTank();
        fetchOption();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveTank = async (data: Tank, id: string) => {
    try {
      setLoading(true);
      const formatData: any = trimAllKey(replaceUndefinedWithNull(data as any), []);
      const emissionControlDetails =
        formatData?.emissionControlDetails?.filter(Boolean)?.map(({ emissionControlId }: any) => ({ emissionControlId: emissionControlId ?? "" })) ?? [];
      data.emissionControlDetails = emissionControlDetails;
      const controlExceptionDate = formatData?.arrControlExceptionDate
        ? convertedDateRangesFromFormat(formatData.arrControlExceptionDate, "YYYY-MM-DD")
        : [];
      const checkboxEmission = formatData?.checkboxEmission;
      const emissionTmp = {
        tvoc: false,
        bz: false,
        bd: false,
        vcm: false,
        edc: false,
      };
      checkboxEmission.forEach((itemEmission: any) => {
        const emissionKey = itemEmission as keyof Emission;
        emissionTmp[emissionKey] = true;
      });

      data = {
        ...data,
        year: selectedYear ?? null,
        companyId: companyId,
        emission: emissionTmp,
      };

      if (controlExceptionDate) {
        data = {
          ...data,
          controlExceptionDate,
        };
      }

      let response;
      if (mode == "insert") {
        response = await createSetupTank(data);
      } else {
        if (id) {
          data = {
            ...data,
            _id: id,
          };
          response = await updateSetupTank(data);
        }
      }
      if (response?.data.code === 200) {
        setLoading(false);
        messageApi.open({
          type: "success",
          content: CommonSuccess.SAVED_SUCCESSFULL,
        });
        processCalculateReport(response.data.data._id);
        fetchTank();
        fetchOption();

        setShowModalTank(false);
        setIsDuplicate(false);
      } else {
        setIsDuplicate(false);
        setShowModalError(true);
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error?.response?.status === 409) {
          setIsDuplicate(true);
        } else {
          setIsDuplicate(false);
          setShowModalError(true);
        }
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const processCalculateReport = async (id: string) => {
    try {
      setLoading(true);
      await calculateReportVocEmission(id);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onTableChange: TableProps<Tank>["onChange"] = (pagination: any, filters: any) => {
    let current = pagination.current;
    setFilter(filters);
    setCurrent(current);
  };

  const showDeleteConfirm = (value: Tank) => {
    const { _id } = value;
    VocsModal.delete({
      onOk: () => {
        if (_id) {
          deleteTank(_id);
        }
      },
    });
  };

  const mapFilter = (key: string): Filter[] | [] => {
    const resultFilter = optionsFilter.find((item) => item.key === key)?.filter;
    if (resultFilter) {
      const filter: Filter[] = resultFilter?.map((value: any) => {
        let text = value;
        if (key === "controlExceptionDate") {
          text = text === EmptyString ? "" : text;
        }
        if (key === "area") {
          text = getMasterLabel("area", text);
        } else if (key === "tankTypeId") {
          text = getMasterLabel("tankTypeId", text);
        } else if (key === "emissionControlId") {
          text = getMasterLabel("emissionControlId", text);
        } else if (key === "efficiency") {
          // console.log("efficiency", text);
          text = getMasterLabel("efficiency", text);
        }
        return {
          text,
          value: value,
        };
      });
      return filter;
    } else {
      return [];
    }
  };

  const resetFilter = () => {
    setFilter({});
  };

  const initData = async () => {
    const query = "";
    try {
      if (profile?.activeCompany._id) {
        setLoading(true);
        await Promise.all([
          getEmission({ type: "global", label: "Emission" }),
          getTankTypeMaster(query),
          getTankEmissionControlMaster(query),
          setCompanyId(profile?.activeCompany._id),
        ]);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (emission[0] && emission[0].options) {
      setEmissionMaster(emission[0].options);
    }
  }, [emission]);

  useEffect(() => {
    initData();
    fetchYear();
  }, []);

  useEffect(() => {
    if (profile?.activeCompany) {
      const fetchData = async () => {
        const companyId = profile.activeCompany._id;
        if (companyId) {
          setSelectedYear(currentYear);
          setCurrent(1);
          resetFilter();
          await Promise.all([getAreaByCompanyId(companyId)]);
          setCompanyId(companyId);
        }
      };
      fetchData();
    }
  }, [profile?.activeCompany]);

  useEffect(() => {
    if (loadingProfile === true) {
      setLoading(true);
    }
  }, [loadingProfile]);

  useEffect(() => {
    resetFilter();
    setCurrent(1);
  }, [selectedYear]);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedYear) {
        await Promise.all([fetchTank(), fetchOption()]);
      }
    };
    fetchData();
  }, [current, filter]);

  const getRowSpan = (index: number, record: any, dataTable: any[]) => {
    if (index === 0 || dataTable[index - 1]._id !== record._id) {
      return dataTable.filter((item) => item._id === record._id).length;
    }
    return 0;
  };

  const onChangePagination: PaginationProps["onChange"] = (page) => {
    setCurrent(page);
  };

  const columns: TableColumnsType<Tank> = [
    // {
    //   title: "No.",
    //   dataIndex: "no",
    //   width: 120,
    //   render: (_, record, index) => {
    //     const arrKeyWarning: string[] = [];
    //     const checkKeys: Array<keyof Tank> = ["area", "tankType"];
    //     checkKeys.forEach((key) => {
    //       if (key === "area") {
    //         const areaLabel = getMasterLabel("area", record[key]);
    //         if (!areaLabel) {
    //           arrKeyWarning.push("Area");
    //         }
    //       } else if (!record[key]) {
    //         const labelMap: { [key: string]: string } = {
    //           tankType: "Tank Type",
    //         };
    //         arrKeyWarning.push(labelMap[key]);
    //       }
    //     });

    //     let displayNo = null;
    //     const rowSpan = getRowSpan(index, record, tankData);

    //     if (rowSpan > 0) {
    //       const previousRows = tankData.slice(0, index);
    //       displayNo = previousRows.filter((_, i) => getRowSpan(i, tankData[i], tankData) > 0).length + 1;
    //     }

    //     return {
    //       children: (
    //         <>
    //           <Row justify="center">
    //             {record.isWarning && <Warning title={`The ${arrKeyWarning.join(", ")} was deleted.`} />}
    //             <div>{record.no}</div>
    //           </Row>
    //         </>
    //       ),
    //       props: {
    //         rowSpan,
    //       },
    //     };
    //   },
    // },
    {
      title: "Tank ID",
      dataIndex: "tankId",
      key: "tankId",
      filteredValue: filter?.tankId || null,
      filters: mapFilter("tankId"),
      render: (text, record, index) => {
        const rowSpan = getRowSpan(index, record, tankData);
        return {
          children: <Text>{text}</Text>,
          props: {
            rowSpan,
          },
        };
      },
    },
    {
      title: "Area",
      dataIndex: "area",
      filteredValue: filter?.area || null,
      filters: mapFilter("area"),
      render: (text, record, index) => {
        const rowSpan = getRowSpan(index, record, tankData);
        return {
          children: <Text>{getMasterLabel("area", text)}</Text>,
          props: {
            rowSpan,
          },
        };
      },
    },
    {
      title: "Chemical Name",
      dataIndex: "chemicalName",
      key: "chemicalName",
      filteredValue: filter?.chemicalName || null,
      filters: mapFilter("chemicalName"),
      render: (text, record, index) => {
        const rowSpan = getRowSpan(index, record, tankData);
        return {
          children: <Text>{text}</Text>,
          props: {
            rowSpan,
          },
        };
      },
    },
    {
      title: "Tank Type",
      dataIndex: "tankType",
      key: "tankTypeId",
      filteredValue: filter?.tankTypeId || null,
      filters: mapFilter("tankTypeId"),
      render: (text, record, index) => {
        const rowSpan = getRowSpan(index, record, tankData);
        return {
          children: <Text>{text}</Text>,
          props: {
            rowSpan,
          },
        };
      },
    },
    {
      title: "Emission Control",
      dataIndex: "emissionControlId",
      key: "emissionControlId",
      render: (text) => <Text>{getMasterLabel("emissionControlId", text)}</Text>,
    },
    // {
    //   title: "Portion (%)",
    //   dataIndex: "portion",
    //   render: (text) => <Text>{text ?? 0}</Text>,
    // },
    {
      title: "Efficiency (%)",
      dataIndex: "emissionControlId",
      render: (text) => <Text>{getMasterLabel("efficiency", text)}</Text>,
    },
    // {
    //   title: "Control Exception Date",
    //   dataIndex: "controlExceptionDate",
    //   width: 520,
    //   filteredValue: filter?.controlExceptionDate || null,
    //   filters: mapFilter("controlExceptionDate"),
    //   render: (controlException: ControlException[], record, index) => {
    //     const rowSpan = getRowSpan(index, record, tankData);
    //     return {
    //       children: (
    //         <div>
    //           {controlException?.map((item, index) => {
    //             return (
    //               <Row key={index + "period"} className={`bg-white-500 rounded-md ${index !== 0 ? "mt-2" : ""}`}>
    //                 <Col span={22}>
    //                   <Tag style={{ backgroundColor: "white", margin: 2, padding: 1 }}>
    //                     <Text className="p-1">
    //                       {item.startDate}
    //                       {" -> "}
    //                       {item.endDate}
    //                     </Text>
    //                   </Tag>
    //                 </Col>
    //                 <Col span={2}>
    //                   <VerticalCenter>
    //                     <CalendarOutlined style={{ fontSize: 18 }} />
    //                   </VerticalCenter>
    //                 </Col>
    //               </Row>
    //             );
    //           })}
    //         </div>
    //       ),
    //       props: {
    //         rowSpan,
    //       },
    //     };
    //   },
    // },
    // {
    //   title: "Emission",
    //   align: "center",
    //   children: emissionMaster?.map((item) => ({
    //     title: item.label,
    //     dataIndex: "emission",
    //     width: "6%",
    //     render: (text, record, index) => {
    //       const rowSpan = getRowSpan(index, record, tankData);
    //       return {
    //         children: (
    //           <div>
    //             <Checkbox checked={text[item.value]} disabled={true}></Checkbox>
    //           </div>
    //         ),
    //         props: {
    //           rowSpan,
    //         },
    //       };
    //     },
    //   })),
    // },
    {
      title: "Action",
      key: "action",
      render: (text, record, index) => {
        const rowSpan = getRowSpan(index, record, tankData);
        return {
          children: (
            <Space>
              <Button
                className="border-transparent bg-transparent"
                size={"small"}
                disabled={!canEditTable(permissions)}
                onClick={() => {
                  onOpenModal("update", record);
                }}
              >
                <BsPencilSquare size={16} color={componentPalette.blueGrey} />
              </Button>
              <Button
                className="border-transparent bg-transparent"
                onClick={() => showDeleteConfirm(text)}
                disabled={!canEditTable(permissions) || record.isFlowActive}
              >
                <BsTrashFill size={16} color={componentPalette.blueGrey} />
              </Button>
            </Space>
          ),
          props: {
            rowSpan,
          },
        };
      },
    },
  ];

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "10px" }}>
        <Select
          value={selectedYear}
          style={{ width: 120 }}
          onChange={onChangeYear}
          options={optionYears.map((year) => ({ label: year, value: year }))}
          loading={loading}
          size="middle"
        />
        {contextHolder}
        <Button
          type="primary"
          size="middle"
          onClick={() => onOpenModal("insert", initialInform)}
          style={{
            display: "flex",
            alignItems: "center",
            visibility: canEditTable(permissions) ? "visible" : "hidden",
          }}
          loading={loading}
        >
          <PlusCircleOutlined />
          New
        </Button>
      </div>
      {showModalTank}
      {showModalTank && dataProp && emissionMaster && (
        <SetupTankModal
          open={showModalTank}
          id={selectedId}
          mode={mode}
          initData={dataProp}
          loading={loading}
          companyId={companyId}
          tankTypeMaster={tankTypeMaster}
          tankEmissionControlMaster={tankEmissionControlMaster}
          emissionMaster={emissionMaster}
          areaMaster={areaMaster}
          isDuplicate={isDuplicate}
          onSave={(data, id) => handleSaveTank(data, id)}
          onDuplicateChange={(isDup) => {
            setIsDuplicate(isDup);
          }}
          onCloseModal={() => {
            setIsDuplicate(false);
            setShowModalTank(false);
          }}
        />
      )}
      <Table
        className="w-full whitespace-nowrap"
        columns={addCenterAlign(columns)}
        rowKey={(record, index) => `${record._id}-${index}`}
        scroll={{ x: "max-content" }}
        dataSource={tankData}
        pagination={false}
        onChange={onTableChange}
        loading={loading}
        rowClassName={(record) => (record.isWarning == true ? "red-border-row" : "")}
      />
      <Pagination
        size={"small"}
        showSizeChanger={false}
        style={{ display: "flex", justifyContent: "right", padding: "7px" }}
        current={current}
        total={total}
        onChange={onChangePagination}
      />
    </div>
  );
};

export default SetupTank;
